var _excluded = ["as", "children", "color", "responsive", "size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import styled from 'styled-components';
var StyledHeading = styled.h3.withConfig({
  componentId: "CL__sc-1rr3htb-0"
})(["font:var(--heading-", ");color:", ";margin:0;@media screen and (max-width:480px){&{", "}}"], _ref => {
  var {
    size
  } = _ref;
  return size;
}, _ref2 => {
  var {
    color
  } = _ref2;
  return color;
}, _ref3 => {
  var {
    responsive,
    size
  } = _ref3;
  return responsive ? "font: var(--heading-".concat(size, "-responsive);") : "";
});
var Heading = /*#__PURE__*/React.forwardRef((_ref4, ref) => {
  var {
      as = 'h3',
      children,
      color = 'var(--text-color)',
      responsive = false,
      size
    } = _ref4,
    props = _objectWithoutProperties(_ref4, _excluded);
  return /*#__PURE__*/React.createElement(StyledHeading, _extends({
    as: as,
    size: size,
    color: color,
    ref: ref,
    responsive: responsive
  }, props), children);
});
export default Heading;